import type {FC, ReactNode} from 'react';
import clsx from 'clsx';

import {Container} from '@/modules/foundation/components/container';
import {ImageBlock} from '@/modules/foundation/components/image/ImageBlock';
import type {ImageWeb} from '@/modules/foundation/components/image/types';
import {Heading} from '@/modules/foundation/components/typography/heading';
import {Paragraph} from '@/modules/foundation/components/typography/paragraph';
import type {PortableTextOverrides} from '@/modules/foundation/sanity/portable-text';
import {formatDate} from '@/modules/foundation/shared/format';

interface Props {
	heading?: string;
	content?: ReactNode;
	lead?: ReactNode;
	createdAt?: string;
	imageWeb?: ImageWeb;
	updatedAt?: string;
}

export const articlePageContentPortableTextOverrides: PortableTextOverrides = {};
export const articlePageLeadPortableTextOverrides: PortableTextOverrides = {};

export const ArticlePage: FC<Props> = ({
	heading,
	content,
	lead,
	createdAt,
	imageWeb,
	// updatedAt,
}) => {
	const formattedDate = formatDate(createdAt ?? '');
	// const formattedUpdatedDate = formatDate(updatedAt ?? '');

	return (
		<>
			<Container width="text" spacingBottom="large" spacingTop="large">
				<div className={clsx('grid', 'gap-2', 'mb-4')}>
					<Paragraph asChild>
						<strong>
							<span className="sr-only">Publisert</span>{' '}
							<time dateTime={createdAt}>{formattedDate}</time>
						</strong>
					</Paragraph>

					{/* {updatedAt !== createdAt && (
					<Paragraph asChild>
						<strong>
							Oppdatert: <time dateTime={updatedAt}>{formattedUpdatedDate}</time>
						</strong>
					</Paragraph>
				)} */}
				</div>
				<Heading spacing>{heading}</Heading>

				{lead && <div className="mb-4 font-bold">{lead}</div>}

				{imageWeb && imageWeb.image && (
					<ImageBlock
						src={imageWeb?.image.src}
						width={imageWeb?.image.width}
						height={imageWeb?.image.height}
						alt={imageWeb?.altText ?? ''}
						className={clsx('rounded-3xl', 'mt-4', 'mb-8')}
					/>
				)}

				<div>{content && <div>{content}</div>}</div>
			</Container>

			<div
				className={clsx(
					'overflow-hidden',
					'absolute',
					'top-0',
					'left-0',
					'right-0',
					'bottom-0',
					'-z-50',
					'before:transition-all',
					'before:rounded-[34%_66%_50%_50%_/_30%_20%_80%_70%]',
					'md:before:rounded-[34%_66%_50%_50%_/_30%_69%_31%_70%]',
					'before:absolute',
					'before:top-32',
					'before:left-1/2',
					'before:-translate-x-1/2',
					'before:h-screen',
					'before:w-[150vw]',
					'before:bg-gradient-to-b',
					'before:from-[#E0F6FF]',
					'before:to-white',
				)}
			/>
		</>
	);
};
